import { render } from "./ChatContactPage.vue?vue&type=template&id=4c840cba&ts=true"
import script from "./ChatContactPage.vue?vue&type=script&lang=ts"
export * from "./ChatContactPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__